import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from '~HOC';
import { Link } from 'react-router-dom';
import { CountDownTimer, SearchTimeout } from '../../../../component';
import {
  returnAllPassengerTitle,
  returnDayWithMonthName,
  returnShamsiDayWithMonthName,
} from '../../../../utils/utility/booking';
// importing svg-components
import {
  StopwatchIcon,
  EditIcon,
  PerviouseIcon,
  NextIcon,
  RandomIcon,
  LeftIcon,
  RightIcon,
  RoundTripIconFa,
  RoundTripIconEn,
} from '~svg';
let intervalId = 0,
  distance = 15;
const MobileFixBanner = ({
  containerClass,
  link,
  onclick,
  passengers,
  origin,
  destination,
  isEdit,
  searchTimeValue,
  backButtonClick,
  callAPI,
  currentWay,
  isIdentifyPage = false,
  ...props
}) => {
  const { location } = props;
  let parsedQueryStr = Object.fromEntries(new URLSearchParams(location.search));
  let { direction } = props.language;

  const [expired, setExpired] = useState(false);
  const [closeTimeOut, setCloseTimeOut] = useState(false);
  let searchTime = sessionStorage.getItem('searchTime');
  let selectedAirport = JSON.parse(sessionStorage.getItem('selectedAirport'));
  // const ways = [
  //   { name: 'booking.onewaytrip' },
  //   { name: 'booking.roundtrip' },
  //   { name: 'booking.multicity' },
  // ];
  // useEffect(() => {
  //   if (!selectedAirport || Object.entries(selectedAirport)?.length === 0)
  //     props.navigate('/');

  //   let countDownDate = new Date(searchTimeValue).getTime() + 15 * 60 * 1000;
  //   var now = new Date().getTime();
  //   console.log('countDownDate is : ', countDownDate);
  //   console.log('now is : ', now);
  //   distance = countDownDate - now;
  //   console.log('distance is : ', distance);
  //   if (distance > 0) showCountDownTimer();
  //   else {
  //     clearInterval(intervalId);
  //     let element = document.getElementById('stopCount');
  //     if (element) {
  //       element.innerHTML = props.intl.formatMessage({
  //         id: 'booking.expirereserve',
  //       });
  //     }
  //   }
  //   return () => clearInterval(intervalId);
  // });

  let passengerTitle = returnAllPassengerTitle(parsedQueryStr, props.intl);
  let originDate = selectedAirport[0].date
    ? props.language.name === 'fa'
      ? returnShamsiDayWithMonthName(
          selectedAirport[0]?.date?.shamsi.join('-'),
          props.language.name,
        )
      : returnDayWithMonthName(
          selectedAirport[0].date.miladi.join('-'),
          props.language.name,
        )
    : '';
  let destinationDate =
    selectedAirport.length > 1 && selectedAirport[1].date
      ? props.language.name === 'fa'
        ? returnShamsiDayWithMonthName(
            selectedAirport[selectedAirport.length - 1]?.date?.shamsi.join('-'),
            props.language.name,
          )
        : returnDayWithMonthName(
            selectedAirport[selectedAirport.length - 1]?.date?.miladi.join('-'),
            props.language.name,
          )
      : '';
  const showCountDownTimer = () => {
    let searchTime = sessionStorage.getItem('searchTime');
    // Update the count down every 1 second
    if (distance > 0 && (searchTime || searchTimeValue)) {
      intervalId = setInterval(() => {
        var countDownDate = new Date(searchTime).getTime() + 15 * 60 * 1000;
        var now = new Date().getTime();
        distance = countDownDate - now;
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Get today's date and time
        // Find the distance between now and the count down date
        // Time calculations for hours, minutes and seconds
        if (seconds < 10 && seconds.toString().length === 1)
          seconds = '0' + seconds;
        if (minutes < 10 && minutes.toString().length === 1)
          minutes = '0' + minutes;
        // Display the result in the element with id="stopCount"
        let element = document.getElementById('stopCount');
        if (element) element.innerHTML = minutes + ':' + seconds;

        // If the count down is finished, write some text
        if (distance < 0 || expired) {
          clearInterval(intervalId);
          setExpired(true);
          setCloseTimeOut(false);
          if (element) {
            element.innerHTML = props.intl.formatMessage({
              id: 'booking.expirereserve',
            });
          }
        }
      }, 1000);
    } else {
      sessionStorage.removeItem('searchTime');
      clearInterval(intervalId);
      let element = document.getElementById('stopCount');
      distance = 15;
      if (element) {
        element.innerHTML = props.intl.formatMessage({
          id: 'booking.expirereserve',
        });
      }
    }
  };
  let element = document.getElementById('stopCount');

  return (
    <div
      className={`align-items-center px-3 py-2 ${
        isIdentifyPage
          ? ' default-border-radius-small'
          : 'default-border-bottom-radius-small'
      } shadow ${containerClass}`}
      style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
    >
      <div
        className="d-flex align-items-center justify-content-start cursor-pointer col-3"
        onClick={() => backButtonClick()}
      >
        {props.language.direction == 'rtl' ? (
          <PerviouseIcon
            size={30}
            color="#3d4a8f"
            variant="svg-small svg-sm-xlarge svg-md-large"
          />
        ) : (
          <NextIcon
            size={30}
            color="#3d4a8f"
            variant="svg-small svg-sm-xlarge svg-md-large"
          />
        )}
      </div>

      <div className="col-6 d-flex flex-column justify-content-center align-items-center font-msmall">
        <div className="w-100 d-flex justify-content-center align-items-center text-primary">
          <div className="px-1">
            {origin
              ? origin
              : selectedAirport[0].origin.city.locationName[
                  props.language.name
                ]}
          </div>
          <div className="px-1 cursor-pointer">
            {parsedQueryStr.ft === 'multicity' ? (
              <RandomIcon
                size={12}
                color="#6c757d"
                variant="svg-xsmall svg-sm-msmall"
              />
            ) : parsedQueryStr.ft === 'roundtrip' ? (
              direction === 'rtl' ? (
                <RoundTripIconFa size={12} color="#aaacaf" />
              ) : (
                <RoundTripIconEn size={12} color="#aaacaf" />
              )
            ) : direction === 'rtl' ? (
              <LeftIcon size={24} color="#aaacaf" />
            ) : (
              <RightIcon size={24} color="#aaacaf" />
            )}
          </div>
          <div className="px-1">
            {destination
              ? destination
              : selectedAirport[
                  parsedQueryStr.ft === 'multicity'
                    ? selectedAirport.length - 1
                    : 0
                ].destination.city.locationName[props.language.name]}
          </div>
          {isEdit ? (
            <Link to="/booking/select-city" className="px-1">
              <EditIcon
                size={14}
                color="#4c54b9"
                variant="svg-tiny svg-sm-small"
              />
            </Link>
          ) : (
            ''
          )}
        </div>
        <div className="w-100 d-flex justify-content-center py-1">
          {currentWay && (
            <span className="text-primary text-nowrap font-smaller">
              (<FormattedMessage id={`booking.${currentWay}`} />)
            </span>
          )}
        </div>
        <div className="passenger-xs w-100 d-flex align-items-center justify-content-center text-nowrap font-smaller font-lg-msmall font-xl-small text-third ">
          {originDate ? (
            <div className="d-flex px-1 text-secondary">
              <span className="px-1">{originDate}</span>
              {destinationDate ? (
                <>
                  <FormattedMessage id="booking.alternativeto" />
                  <span className="px-1">{destinationDate}</span>
                </>
              ) : null}
            </div>
          ) : null}
          <div className="d-flex px-1">
            {Object.entries(passengers).length ? (
              <>
                <div className="px-1">
                  {passengers.adult}
                  <span className="px-1">
                    <FormattedMessage id="booking.adult" />
                  </span>
                </div>
                <div className="px-1">,</div>
                <div className="px-1">
                  {passengers.child}
                  <span className="px-1">
                    <FormattedMessage id="booking.child" />
                  </span>
                </div>
                <div className="px-1">,</div>
                <div className="px-1">
                  {passengers.infant}
                  <span className="px-1">
                    <FormattedMessage id="booking.infant" />
                  </span>
                </div>
              </>
            ) : (
              passengerTitle
            )}
          </div>
        </div>
      </div>
      {(searchTime || searchTimeValue) && window.innerWidth < 992 ? (
        <div className="col-3 d-flex justify-content-end align-items-center px-1">
          <CountDownTimer
            intl={props.intl}
            showSearchTimeOut={() => {
              setExpired(true);
            }}
            closeTimeOut={closeTimeOut}
            direction={direction}
            isMobile={true}
          />
        </div>
      ) : null}
      {expired && !closeTimeOut ? (
        <SearchTimeout
          titleMessage="booking.searchtimeout"
          errorMessage="booking.searchagaininfo"
          message="booking.searchagaininfomsg"
          headerMessage="booking.timeout"
          hideSearchTimeOut={() => {
            document.body.classList.remove('modal-open');
            setCloseTimeOut(true);
          }}
          searchAgain={() => {
            document.body.classList.remove('modal-open');
            setCloseTimeOut(true);
            setExpired(false);
            distance = 15;
            callAPI();
          }}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

MobileFixBanner.propTypes = {
  containerClass: PropTypes.string,
  link: PropTypes.string,
  passengers: PropTypes.object,
  onclick: PropTypes.func,
  origin: PropTypes.string,
  destination: PropTypes.string,
  isEdit: PropTypes.bool,
  searchTimeValue: PropTypes.instanceOf(Date),
  callAPI: PropTypes.func,
};
MobileFixBanner.defaultProps = {
  containerClass: 'd-flex d-lg-none',
  passengers: {},
  isEdit: true,
  searchTimeValue: null,
  callAPI: () => console.error('There is not function'),
};
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(
  withRouter(connect(mapStateToProps)(MobileFixBanner)),
);
/** UseAge

  containerClass:'font-small font-sm-large',      main container class
  link: /about,                     link to defined route if you dont set this props it's show simple <i/> whit defined onclick
  passengers: Object,                             if you dont set this props it's read data from props.location.search     
  onclick: Function,                              for <i/> or <Link/>
  origin: String,                                 if you dont set this props it's read data from LocalStroage 
  destination: String,                            if you dont set this props it's read data from LocalStroage 

Examples

 -use Link Route
<MobileFixBanner
  containerClass="font-smal font-lg-large"
  link="/about"
  passengers={ adult: 1, child: 1, infant: 1 }
  origin="Shiraz"
  destination="Tehran"
  onclick={() => alert('FixBanner')}
  />

 -use <i/>
<MobileFixBanner
  containerClass='font-smal font-lg-large'
  passengers={ adult: 1, child: 1, infant: 1 }
  origin="Shiraz"
  destination="Tehran"
  onclick={() => alert('FixBanner')}
  />
*/
